module.exports = __webpack_public_path__ + "img/title-4.d06c0fff.png";